import './index.css'
import dayjs from '@disco/utils/dayjs'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getGroupsLoading } from '@disco/state-management/selectors/groups'
import Button from 'components/ui/button'
import Heading from 'components/ui/heading'
import Spinner from 'components/ui/spinner'
import NotificationItem from './notification-item'

class NotificationPane extends Component<any> {
  render() {
    // TODO: DEPRECATED (props.timeline is not used)
    const { hasScrollBar, timeline, groupsLoading } = this.props
    const hasScrollBarClass = hasScrollBar
      ? 'NotificationPane_HasScrollBar'
      : ''
    return (
      <div className="NotificationPane">
        <div className="NotificationPane_Header">
          <Heading size={400}>Notifications</Heading>
          <div className="NotificationPane_Header_Actions">
            <Button
              appearance="inline-link"
              caption="Clear all"
              compact={true}
              disabled={this.props.notifications.length === 0 || groupsLoading}
              onClick={this.props.onClearAll}
            />
          </div>
        </div>
        <div className={`NofiticationPane_ScrollCont ${hasScrollBarClass}`}>
          {groupsLoading ? (
            <Spinner />
          ) : (
            <div className="NofiticationPane_Body">
              {timeline && this._renderTimelineBackground()}
              {this._renderNotifications()}
            </div>
          )}
        </div>
      </div>
    )
  }

  _renderNotifications() {
    const { notifications } = this.props

    if (notifications.length > 0) {
      return notifications.map(this._renderNotification)
    } else {
      return (
        <div className="NotificationPane_Empty">
          You don’t have any notifications
        </div>
      )
    }
  }

  _renderNotification = (item, index, notifications) => {
    const { timeline, onOpenNotification, onDismiss } = this.props
    return (
      <NotificationItem
        key={item.api_url || item.message_id}
        item={item}
        hasDismissButton={this.props.hasDismissButton}
        timelineItem={
          timeline
            ? this._renderTimelineItem({
                timestamp: item.timestamp,
                isFirst: index === 0,
                isLast: index === notifications.length - 1,
              })
            : null
        }
        onOpenNotification={onOpenNotification}
        onExpandNotification={this.props.onExpandNotification}
        onDismiss={onDismiss}
        onOpenPlaylist={this.props.onOpenPlaylist}
        onOpenBriefSubmission={this.props.onOpenBriefSubmission}
        onAcceptChannelInvite={this.props.onAcceptChannelInvite}
        onOpenLibraryClients={this.props.onOpenLibraryClients}
        onOpenTrackRoute={this.props.onOpenTrackRoute}
        onClickLink={this.props.onClickLink}
      />
    )
  }

  _renderTimelineBackground() {
    return (
      <div className="NotificationPane_TimelineBackground">
        <div className="NotificationPane_TimelineLine" />
      </div>
    )
  }

  _renderTimelineItem({ timestamp, isFirst, isLast }) {
    const isFirstClass = isFirst ? 'NotificationPane_IsFirst' : ''
    const isLastClass = isLast ? 'NotificationPane_IsLast' : ''
    return (
      <div
        className={`NotificationPane_TimelineCont ${isFirstClass} ${isLastClass}`}
      >
        <div className="NotificationPane_TimelineBox">
          {dayjs(timestamp).format('MMM D')}
        </div>
      </div>
    )
  }
}

export default connect(state => {
  return {
    groupsLoading: getGroupsLoading(state),
  }
})(NotificationPane)
